import { StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    paddingTop: 35,
    paddingBottom: 100,
    paddingHorizontal: 35,
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 20,
  },
  logo: {
    width: '50%',
    height: '100%',
  },
  header: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#005b96',
  },
  detailsContainer: {
    position: 'absolute',
    top: 70,
    right: 35,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#000',
    padding: 5,
    width: 250,
  },
  offerDetails: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    width: '100%',
  },
  detailColumn: {
    alignItems: 'center',
  },
  detailLabel: {
    fontSize: 10,
  },
  detailValue: {
    fontSize: 10,
    fontWeight: 'bold',
    margin: 2,
  },
  contentContainer: {
    flexGrow: 1,
    justifyContent: 'flex-start',
    marginBottom: 20,
  },
  detailsRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 20,
    marginTop: 50,
  },
  clientInfoContainer: {},
  clientInfoTitle: {
    fontSize: 10,
    marginBottom: 3,
  },
  clientInfo: {
    fontSize: 11,
    fontWeight: 'bold',
    marginVertical: 2,
  },
  productsSection: {
    marginBottom: 20,
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 0,
    marginBottom: 10,
  },
  headerRow: {
    flexDirection: 'row',
    borderBottomColor: '#005b96',
    borderBottomWidth: 1,
    alignItems: 'center',
    height: 24,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 0,
    alignItems: 'center',
    height: 24,
  },
  tableCellHeader: {
    fontSize: 10,
    fontWeight: 'bold',
    color: '#005b96',
    margin: 5,
  },
  tableCell: {
    fontSize: 10,
    margin: 5,
    lineHeight: 1.2,
  },
  totalsContainer: {
    alignItems: 'flex-start',
  },
  totalsRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
  totalsLabel: {
    fontSize: 10,
    width: '80%',
    textAlign: 'right',
    color: '#005b96',
  },
  totalsValue: {
    fontSize: 10,
    width: '20%',
    textAlign: 'right',
    marginBottom: 5,
  },
  footerContainer: {
    position: 'absolute',
    bottom: 0,
    left: 15,
    right: 15,
    paddingHorizontal: 15,
    paddingTop: 10,
  },
  footerText: {
    fontSize: 10,
    textAlign: 'left',
    marginBottom: 3,
  },
  footerWebsite: {
    fontSize: 10,
    textAlign: 'left',
    color: '#005b96',
    marginBottom: 5,
  },
  footerRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    marginBottom: 10,
  },
  footerLeftColumn: {
    width: '50%',
  },
  footerRightColumn: {
    width: '50%',
    textAlign: 'right',
  },
  footerTotals: {
    textAlign: 'right',
  },
  footerTotalsText: {
    fontSize: 10,
    textAlign: 'right',
    color: '#005b96',
  },
  footerTotalsValues: {
    textAlign: 'right',
  },
  footerTotalsValue: {
    fontSize: 10,
    textAlign: 'right',
    color: '#005b96',
    marginBottom: 3,
  },
  footerBottomRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  footerBottomText: {
    fontSize: 10,
    textAlign: 'left',
    marginBottom: 3,
  },
  footerBorder: {
    borderTop: '2px solid #005b96',
    marginVertical: 5,
  },
  footerIconsRow: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    marginTop: 10,
  },
});

export default styles;
